export const LanguageNavigationStyles = {
	"sx": {
		".mobile-hygiene &": {
			".language-nav__item-splitter": {
				px: ["7", null, null, "2"]
			}
		},
		".language-nav__item": {
			transitionDuration: ".750s",
			transitionTimingFunction: "ease-in-out",
			transitionProperty: "color",
			fontFamily: "body",
			fontWeight: '400',
			lineHeight: 'base',

			"&--en": {
				fontSize: ".75rem",
				letterSpacing: 'wider',
			},

			"&--ar": {
				fontSize: "1rem",
				letterSpacing: "0"
			},

			"&:hover, &:focus": {
				color: "primary.aramcoBlue",
			},
		}
	}
}